import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasLink", "icon", "onClick", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var ActionBarItemListItem = function ActionBarItemListItem(props) {
  var hasLink = props.hasLink,
    icon = props.icon,
    onClick = props.onClick,
    className = props.className,
    children = props.children,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('ActionBarItemListItem', className);
  var iconClasses = classNames('ActionBarItemListItemIcon', 'rioglyph', icon);
  var btnClasses = classNames('ActionBarItemListItemButton');
  return /*#__PURE__*/React.createElement("li", _extends({}, remainingProps, {
    className: classes
  }), icon && /*#__PURE__*/React.createElement("span", {
    className: iconClasses
  }), hasLink && !onClick && /*#__PURE__*/React.createElement("span", null, children), onClick && /*#__PURE__*/React.createElement("div", {
    className: btnClasses,
    onClick: onClick
  }, children), !hasLink && !onClick && children);
};
ActionBarItemListItem.displayName = 'ActionBarItemListItem';
ActionBarItemListItem.propTypes = {
  hasLink: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
};
export default ActionBarItemListItem;